import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=09ff5a22&scoped=true"
import script from "./SearchPage.vue?vue&type=script&lang=ts"
export * from "./SearchPage.vue?vue&type=script&lang=ts"
import style0 from "./SearchPage.vue?vue&type=style&index=0&id=09ff5a22&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff5a22",
  null
  
)

export default component.exports